import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';


const HTMLSource = ({ html, height }) => {
    const ref = useRef(null);

    useEffect(() => {
        const container = ref.current;

        if (!container) {
            return;
        }

        let tmpEl = document.createElement('div');

        tmpEl.innerHTML = html;

        let tmpArr = tmpEl.children;
        tmpArr = [...tmpArr];

        tmpArr.map(el => {
            if (el.nodeName === 'SCRIPT') {
                if (el.src) {
                    const script = document.createElement('script');

                    script.src = el.src;
                    container.append(script);
                } else {
                    eval(el.innerHTML);
                }
            } else {

                if (el.nodeName === 'IFRAME' && height) {
                    el.height = height;
                }

                container.appendChild(el);
            }
        });

        tmpEl = null;
        return () => { };
    }, [ref.current, html, height]);

    return (
        <div ref={ref}></div>
    );
};

export default HTMLSource;

HTMLSource.propTypes = {
    html: PropTypes.string,
    height: PropTypes.string
};
